import { S, singleQuiz, multiQuiz, opt } from './schema.js';

const ABC = (a, b, c) => [opt('A', a), opt('B', b), opt('C', c)];

export const ESCUDO = {
  id: 'escudo-estelar',
  order: 1,
  title: 'Escudo Estelar',
  mission: 'Missão Escudo Estelar',
  level: 'Básico',
  courseLabel: 'Curso 1 de 3',
  kicker: 'Obrigatório · certificado no final',
  startLabel: 'Começar',
  nextCourseId: 'cofre-quantico',
  nextButtonLabel: 'Começar o Curso 2',
  certName: 'Curso 1 · Básico · Missão Escudo Estelar',
  certBody:
    'Carga: 30 slides · dado pessoal, bases legais, direitos do titular. Este certificado libera o Curso 2.',
  theme: 'escudo',
  slides: [
    S(
      1,
      'A Teca te chama',
      'teca-acena',
      'Oi. Eu sou a Teca. Hoje a gente protege gente de verdade — os clientes da loja, os colegas, você. São 20 minutos. Sem juridiquês.',
      'Começar',
      {
        type: 'hero',
        heading: 'Missão Escudo Estelar',
        kicker: 'Curso 1 de 3',
        badge: 'Obrigatório · certificado no final',
      },
    ),
    S(
      2,
      'A Vaza já entrou',
      'teca-alerta',
      'Na Padaria Estrela alguém levantou e deixou a retaguarda aberta. A Vaza copiou a lista de delivery. Nome, telefone, endereço. Isso não é “só uma planilha”. É a vida de gente.',
      'Quero o escudo',
      {
        type: 'cards',
        stamp: 'dado pessoal',
        items: [
          { title: 'Nome', body: 'Maria da Padaria Estrela' },
          { title: 'Telefone', body: 'o número do pedido' },
          { title: 'Endereço', body: 'a rua da entrega' },
        ],
      },
      { vaza: true },
    ),
    S(
      3,
      'Dado pessoal, em uma frase',
      'teca-explica',
      'Dado pessoal é qualquer informação que dá para saber de quem é. CPF, claro. Mas também e-mail, foto do crachá, o pedido “do João da mesa 4”, o áudio no WhatsApp do suporte.',
      'Continuar',
      {
        type: 'compare',
        left: {
          title: 'É dado pessoal',
          body: 'dá para identificar a pessoa',
        },
        right: {
          title: 'Não é (de verdade)',
          body: 'anonimizado de um jeito que ninguém desfaz',
        },
      },
    ),
    S(
      4,
      'Tratamento é quase tudo',
      'teca-explica',
      'A lei não pega só “guardar no banco”. Pegar, anotar, mandar no Slack, imprimir, usar no BI, apagar: tudo isso é tratar dado. Se você mexeu, a lei olha.',
      'Continuar',
      {
        type: 'timeline',
        steps: ['coletar', 'usar', 'guardar', 'compartilhar', 'apagar'],
      },
      {
        orientation:
          'Print de tela da retaguarda no grupo da loja = tratamento. Não é fofoca. É lei.',
      },
    ),
    S(
      5,
      'O dono não é a Altec',
      'teca-explica',
      'O dono do dado é a pessoa. A lei chama ela de titular. A padaria e a Altec usam o dado. Não donam a pessoa.',
      'Continuar',
      {
        type: 'roles',
        items: [
          {
            title: 'Titular',
            body: 'a pessoa',
            tip: 'Quem a lei protege. Dono do dado.',
          },
          {
            title: 'Controlador',
            body: 'quem decide o “para quê” (em geral, o restaurante, no dado do cliente)',
            tip: 'Decide por que o dado existe na operação.',
          },
          {
            title: 'Operador',
            body: 'quem trata por conta do controlador (muitas vezes, a Altec)',
            tip: 'Trata no contrato, não inventa finalidade.',
          },
        ],
      },
      {
        orientation:
          'Dado de funcionário Altec: aí a Altec é controladora. Dois chapéus. Mesma regra: respeito.',
      },
    ),
    S(
      6,
      'Os 10 princípios, sem lista de artigo',
      'teca-explica',
      'Dez ideias seguram a casa. As que você usa todo dia: só pegar o que precisa, só para o motivo certo, cuidar para não vazar, e conseguir mostrar que cuidou.',
      'Continuar',
      {
        type: 'stones',
        items: ['preciso', 'motivo certo', 'seguro', 'dá para provar'],
      },
    ),
    S(
      7,
      'No seu posto, agora',
      'teca-alerta',
      'Antes do café, três hábitos: bloquear a tela, não mandar dado de cliente no grupo, não levar planilha no pendrive da mochila.',
      'Entendi, vamos em frente',
      {
        type: 'checklist',
        items: [
          'Bloquear a tela',
          'Não mandar dado de cliente no grupo',
          'Não levar planilha no pendrive da mochila',
        ],
      },
    ),
    S(
      8,
      'Recap da mini-aula 1',
      'teca-explica',
      'Guarda assim: se identifica alguém, é dado pessoal. Mexer é tratar. O dono é a pessoa. A Altec às vezes opera, às vezes controla. Tela bloqueada.',
      'Me pergunta',
      {
        type: 'pills',
        items: [
          'identifica = pessoal',
          'mexer = tratar',
          'dono = a pessoa',
          'tela bloqueada',
        ],
      },
    ),
    S(
      9,
      'Pergunta 1',
      'teca-pensa',
      'O caixa busca o pedido do João pelo telefone. Isso é dado pessoal?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt: 'O caixa busca o pedido do João pelo telefone. Isso é dado pessoal?',
        scored: singleQuiz({
          items: ['c1-q1'],
          options: ABC(
            'Não, telefone é da loja',
            'Sim, dá para saber quem é o João',
            'Só se tiver CPF',
          ),
          correct: 'B',
          gabaritoCerto: 'Isso. Telefone + nome do pedido identificam o João.',
          gabaritoErrado:
            'Não precisa de CPF. Se dá para saber quem é, já é dado pessoal.',
        }),
      },
    ),
    S(
      10,
      'Pergunta 2',
      'teca-pensa',
      'Você manda no Slack da loja um print da tela com nome e telefone de clientes. A lei considera isso o quê?',
      'Continuar a missão',
      { type: 'quiz' },
      {
        prompt:
          'Você manda no Slack da loja um print da tela com nome e telefone de clientes. A lei considera isso o quê?',
        scored: singleQuiz({
          items: ['c1-q2'],
          options: ABC(
            'Só conversa interna',
            'Tratamento de dado pessoal',
            'Problema só se alguém de fora ver',
          ),
          correct: 'B',
          gabaritoCerto:
            'Compartilhar internamente também é tratar. O grupo da loja não é cofre.',
          gabaritoErrado:
            'Compartilhar internamente também é tratar. O grupo da loja não é cofre.',
        }),
      },
    ),
    S(
      11,
      'Consentimento não é a única chave',
      'teca-explica',
      'Muita gente acha que LGPD = “pede o aceite”. Não. A lei tem dez chaves. Consentimento é uma. NFC-e com CPF, folha de pagamento e log de segurança quase nunca andam nessa chave.',
      'Mostra as outras',
      {
        type: 'locks',
        main: 'consentimento',
        around: 9,
      },
    ),
    S(
      12,
      'Chaves do dia a dia na Altec',
      'teca-explica',
      'As que mais aparecem aqui: obrigação legal (nota, folha), contrato (o cliente pediu o delivery), legítimo interesse (melhorar o produto sem atropelar a pessoa).',
      'Continuar',
      {
        type: 'cards',
        items: [
          { title: 'Obrigação legal', body: 'emitir NFC-e' },
          { title: 'Contrato', body: 'entregar o pedido que a pessoa fez' },
          {
            title: 'Legítimo interesse',
            body: 'com cuidado, nunca por cima da pessoa',
          },
        ],
      },
    ),
    S(
      13,
      'As outras sete, em uma respiração',
      'teca-explica',
      'Ainda existem: política pública, pesquisa de órgão de pesquisa, processo judicial, proteger a vida, tutelar a saúde, proteção ao crédito, e os procedimentos antes do contrato quando a pessoa pede.',
      'Continuar',
      {
        type: 'list',
        items: [
          'política pública',
          'pesquisa de órgão de pesquisa',
          'processo judicial',
          'proteger a vida',
          'tutelar a saúde',
          'proteção ao crédito',
          'procedimentos antes do contrato (a pessoa pede)',
        ],
      },
    ),
    S(
      14,
      'O que você não faz',
      'teca-alerta',
      'Você não inventa a chave. Não marca “aceito” no lugar do cliente. Não desliga a coleta de CPF na nota “porque a LGPD mandou” — a nota é obrigação legal.',
      'Continuar',
      {
        type: 'dont',
        items: ['Inventar base', 'Clicar aceite pelos outros'],
      },
    ),
    S(
      15,
      'Pedir menos',
      'teca-explica',
      'Se o delivery precisa de endereço, não pede RG. Se o suporte precisa do pedido, não pede a foto do documento no grupo. Menos dado, menos Vaza.',
      'Continuar',
      {
        type: 'callout',
        body: 'Antes de criar campo novo na tela: “eu preciso mesmo disso?”',
      },
      { vaza: true },
    ),
    S(
      16,
      'Recap da mini-aula 2',
      'teca-explica',
      'Dez chaves. Consentimento é uma. A sua função não é escolher a chave no chute — é tratar só o necessário e não furar o que a empresa já combinou.',
      'Me pergunta de novo',
      {
        type: 'pills',
        items: ['dez chaves', 'consentimento é uma', 'só o necessário'],
      },
    ),
    S(
      17,
      'Pergunta 3',
      'teca-pensa',
      'Para emitir a NFC-e com CPF, a loja precisa do aceite de cookies no totem?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Para emitir a NFC-e com CPF, a loja precisa do aceite de cookies no totem?',
        scored: singleQuiz({
          items: ['c1-q3'],
          options: ABC(
            'Sim, sem aceite não pode',
            'Não. Nota fiscal é obrigação legal',
            'Só se o cliente for menor',
          ),
          correct: 'B',
          gabaritoCerto:
            'Obrigação legal é uma chave própria. Consentimento não segura a nota.',
          gabaritoErrado:
            'Obrigação legal é uma chave própria. Consentimento não segura a nota.',
        }),
      },
    ),
    S(
      18,
      'Pergunta 4',
      'teca-pensa',
      'O marketing quer o celular de todo mundo que passou na loja, “por via das dúvidas”. Pode?',
      'Última volta',
      { type: 'quiz' },
      {
        prompt:
          'O marketing quer o celular de todo mundo que passou na loja, “por via das dúvidas”. Pode?',
        scored: singleQuiz({
          items: ['c1-q4'],
          options: ABC(
            'Sim, legítimo interesse cobre tudo',
            'Não. Só o necessário, com chave certa. “Por via das dúvidas” não é chave',
            'Sim, se apagar em 24 horas',
          ),
          correct: 'B',
          gabaritoCerto:
            '“Por via das dúvidas” é a Vaza sorrindo. Pega só o que o motivo pede.',
          gabaritoErrado:
            '“Por via das dúvidas” é a Vaza sorrindo. Pega só o que o motivo pede.',
        }),
      },
    ),
    S(
      19,
      'A pessoa pode pedir',
      'teca-explica',
      'A qualquer momento a pessoa pode pedir: o que vocês têm de mim? Corrigir o nome. Apagar o que não precisa. Saber com quem compartilhou. Tirar o aceite que ela deu.',
      'E eu, o que faço?',
      {
        type: 'icons',
        items: [
          'ver',
          'corrigir',
          'apagar o excesso',
          'com quem foi',
          'tirar o aceite',
        ],
      },
    ),
    S(
      20,
      'Você não resolve sozinho',
      'teca-alerta',
      'Chegou pedido no Instagram, no caixa, no WhatsApp do suporte: você não apaga, não exporta, não inventa prazo. Encaminha para o canal do Encarregado. Anota data e hora.',
      'Continuar',
      {
        type: 'flow',
        steps: ['recebeu', 'não mexe', 'encaminha', 'confirma que chegou'],
      },
      {
        orientation:
          'Canal placeholder privacidade@altec.ws (DPO confirma na semana 4)',
      },
    ),
    S(
      21,
      'Apagar não é sempre',
      'teca-explica',
      'A pessoa pede para apagar. Às vezes a nota fiscal ainda precisa existir. Às vezes o processo na Justiça segura o dado. Encaminha. Quem decide o “pode apagar” não é o grupo da loja.',
      'Continuar',
      {
        type: 'columns',
        left: { title: 'dá para atender', body: 'excesso, dado irregular' },
        right: { title: 'a lei manda guardar', body: 'nota, processo, obrigação' },
      },
    ),
    S(
      22,
      'Decisão de máquina',
      'teca-explica',
      'Se um sistema sozinho decide algo que mexe com a pessoa — crédito, bloqueio, fila — ela pode pedir revisão. No avançado a gente aprofunda. Aqui: não fale “foi o robô, não tem jeito”.',
      'Continuar',
      {
        type: 'callout',
        body: 'Não feche a porta com “foi o robô”.',
      },
    ),
    S(
      23,
      'A Vaza no pedido',
      'teca-alerta',
      'Cuidado com golpe: alguém se passando pelo cliente pede “me manda tudo que vocês têm”. Identidade primeiro. Encaminha. Não anexa a planilha no privado.',
      'Continuar',
      {
        type: 'dont',
        items: [
          'Mandar arquivo sem identidade',
          'Resolver no privado do WhatsApp',
        ],
      },
      { vaza: true },
    ),
    S(
      24,
      'Recap da mini-aula 3',
      'teca-explica',
      'A pessoa manda na lei. Você encaminha. Não apaga por conta. Não entrega dado para quem não provou ser a pessoa.',
      'Últimas perguntas',
      {
        type: 'pills',
        items: ['encaminha', 'não apaga sozinho', 'identidade primeiro'],
      },
    ),
    S(
      25,
      'Pergunta 5',
      'teca-pensa',
      'Uma cliente manda no WhatsApp do caixa: “me apaga de tudo agora”. O que você faz?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Uma cliente manda no WhatsApp do caixa: “me apaga de tudo agora”. O que você faz?',
        scored: singleQuiz({
          items: ['c1-q5'],
          options: ABC(
            'Apaga o cadastro na hora, para ficar bem',
            'Encaminha ao canal de privacidade, anota o pedido, não mexe no dado',
            'Ignora, porque WhatsApp não vale',
          ),
          correct: 'B',
          gabaritoCerto:
            'Pedido vale de qualquer canal. Quem mexe no dado é o fluxo oficial.',
          gabaritoErrado:
            'Pedido vale de qualquer canal. Quem mexe no dado é o fluxo oficial.',
        }),
      },
    ),
    S(
      26,
      'Pergunta 6',
      'teca-pensa',
      'Um número desconhecido pede “sou o João, me manda o extrato dos pedidos”. E agora?',
      'Ver a resposta',
      { type: 'quiz' },
      {
        prompt:
          'Um número desconhecido pede “sou o João, me manda o extrato dos pedidos”. E agora?',
        scored: singleQuiz({
          items: ['c1-q6'],
          options: ABC(
            'Manda, cliente sempre tem razão',
            'Não manda. Encaminha. Identidade primeiro',
            'Manda só os últimos 7 dias',
          ),
          correct: 'B',
          gabaritoCerto:
            'Dado na mão errada é a Vaza. Identidade antes de qualquer arquivo.',
          gabaritoErrado:
            'Dado na mão errada é a Vaza. Identidade antes de qualquer arquivo.',
        }),
      },
    ),
    S(
      27,
      'Tarefa aplicada',
      'teca-pensa',
      'Marque o que é dado pessoal nesta tela da Padaria Estrela.',
      'Fechar o escudo',
      { type: 'quiz' },
      {
        prompt: 'Marque o que é dado pessoal nesta tela da Padaria Estrela.',
        scored: multiQuiz({
          items: [
            { id: 'c1-q7', kind: 'multi-part', mustInclude: ['nome'] },
            { id: 'c1-q8', kind: 'multi-part', mustInclude: ['telefone'] },
            {
              id: 'c1-q9',
              kind: 'multi-part',
              mustInclude: ['foto'],
              mustExclude: ['coxinha'],
            },
          ],
          options: [
            opt('nome', 'Nome da cliente Maria'),
            opt('telefone', 'Telefone'),
            opt('coxinha', 'Sabor da coxinha mais vendida da loja (sem pessoa)'),
            opt('foto', 'Foto do comprovante com CPF'),
          ],
          gabaritoCerto:
            'A coxinha campeã, sozinha, não identifica ninguém. O resto, sim.',
          gabaritoErrado:
            'A coxinha campeã, sozinha, não identifica ninguém. O resto, sim.',
        }),
      },
    ),
    S(
      28,
      'O que já caiu',
      'teca-explica',
      'Repete comigo: dado pessoal identifica gente. Tratar é mexer. Dono é a pessoa. Consentimento não é a única chave. Pedido se encaminha.',
      'Continuar',
      {
        type: 'steps',
        items: [
          'dado pessoal identifica gente',
          'tratar é mexer',
          'dono é a pessoa',
          'consentimento não é a única chave',
          'pedido se encaminha',
        ],
      },
    ),
    S(
      29,
      'Hábitos de ouro',
      'teca-alerta',
      'Bloqueia a tela. Não manda dado de cliente no grupo. Não leva planilha para casa. Viu pedido de titular: encaminha.',
      'Emitir certificado',
      {
        type: 'habits',
        items: [
          'Bloqueia a tela',
          'Não manda dado de cliente no grupo',
          'Não leva planilha para casa',
          'Pedido de titular: encaminha',
        ],
      },
    ),
    S(
      30,
      'Certificado Escudo Estelar',
      'teca-festeja',
      'Escudo no peito. Você concluiu o básico. Daqui a alguns dias a gente abre o Cofre Quântico — senha, dado sensível e o que fazer se vazar. Não faça os três hoje.',
      'Baixar certificado',
      { type: 'certificate' },
    ),
  ],
};
